import { FC } from 'react';
import { Award } from 'lucide-react';
import { CertificationsList } from './CertificationsList';
import type { TherapistProfile } from '../../../../types/therapist-dashboard.types';

export interface CertificationsSectionProps {
  certifications: TherapistProfile['certifications'];
}

export const CertificationsSection: FC<CertificationsSectionProps> = ({
  certifications,
}) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700 p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-slate-100 mb-4 flex items-center gap-2">
        <Award className="w-5 h-5" />
        Certifications
      </h3>
      <p className="text-sm text-gray-600 dark:text-slate-400 mb-4">
        Your professional certifications and licenses.
      </p>
      <CertificationsList certifications={certifications} />
    </div>
  );
};
